import {
  initialState,
  Actions,
  State,
  GET_ALL_RESPONSIBLES,
  GET_ALL_RESPONSIBLES_SUCCESS,
  GET_ALL_RESPONSIBLES_ERROR,
  RESET_GET_ALL_RESPONSIBLES,
} from '../../types/responsible/get-all'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_RESPONSIBLES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_RESPONSIBLES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_RESPONSIBLES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ALL_RESPONSIBLES:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
